module.exports = __webpack_public_path__ + "static/media/piscina.b10f14c0.svg";